import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020d93f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"width":"auto","max-width":"none"}
}
const _hoisted_4 = {
  key: 0,
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_5 = { class: "F-Bold M-Auto" }
const _hoisted_6 = { class: "F-Bold M-Auto" }
const _hoisted_7 = { class: "W-100" }
const _hoisted_8 = {
  key: 0,
  class: "DialogSection",
  id: "TableToPrint1",
  style: {"gap":"0"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_11 = {
  class: "W-100 F-Bold F1_25em JustPrint",
  style: {"text-align":"center"}
}
const _hoisted_12 = { style: {"border-bottom":"1px solid rgba(0,0,0,0.4)"} }
const _hoisted_13 = {
  class: "W-100 F-Bold F1_25em colorMain JustPrint",
  style: {"text-align":"end"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_15 = {
  class: "W-100 D-Flex JustPrint",
  style: {"text-align":"start"}
}
const _hoisted_16 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_17 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_18 = {
  class: "W-100 D-Flex JustPrint",
  style: {"text-align":"start"}
}
const _hoisted_19 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_20 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_21 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_22 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_23 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_24 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_27 = {
  class: "W-100 F-Bold F1_25em JustPrint",
  style: {"text-align":"center"}
}
const _hoisted_28 = { style: {"border-bottom":"1px solid rgba(0,0,0,0.4)"} }
const _hoisted_29 = {
  class: "W-100 F-Bold F1_25em colorMain JustPrint",
  style: {"text-align":"end"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_31 = {
  class: "W-100 D-Flex JustPrint",
  style: {"text-align":"start"}
}
const _hoisted_32 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_33 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_34 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_35 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_36 = {
  class: "W-25 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.5)"}
}
const _hoisted_37 = {
  class: "W-75 P1em",
  style: {"border":"0.3pt solid rgba(0,0,0,0.4)"}
}
const _hoisted_38 = {
  key: 3,
  class: "W-25 P1em"
}
const _hoisted_39 = {
  key: 4,
  class: "W-75 P1em"
}
const _hoisted_40 = {
  key: 6,
  class: "W-25 P1em"
}
const _hoisted_41 = {
  key: 7,
  class: "W-75 P1em"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "W-100 D-Flex JustPrint",
  style: {"text-align":"start"}
}, null, -1))
const _hoisted_44 = {
  class: "W-100 D-Flex JustPrint",
  style: {"min-height":"8em","text-align":"start"}
}
const _hoisted_45 = {
  class: "P_5em",
  style: {"flex":"1","border":"0.3pt solid rgba(0,0,0,0.4)","min-height":"5em"}
}
const _hoisted_46 = { class: "F-Bold" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = {
  key: 0,
  class: "P_5em",
  style: {"flex":"1","border":"0.3pt solid rgba(0,0,0,0.4)","min-height":"5em"}
}
const _hoisted_49 = { class: "F-Bold" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_51 = {
  key: 9,
  class: "JustPrint D-Flex W-100 F2_5em",
  style: {"margin-top":"5pt"}
}
const _hoisted_52 = {
  class: "Rad3",
  style: {"border":"1px solid var(--colorr1)","padding":"0.5em 1em"}
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer" }, null, -1))
const _hoisted_55 = {
  key: 1,
  class: "D-Flex",
  style: {"gap":"1em"}
}
const _hoisted_56 = { class: "F-Bold M-Auto" }
const _hoisted_57 = { class: "F-Bold M-Auto" }
const _hoisted_58 = {
  key: 2,
  class: "DialogSection",
  id: "TableToPrint2"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_61 = {
  key: 0,
  class: "pagebreak F1_5em CookiesRowSpacer JustPrint"
}
const _hoisted_62 = {
  key: 1,
  class: "pagebreak F1_5em CookiesRowSpacer JustPrint"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak CookiesRowSpacer JustPrint" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRow F-C2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving || _ctx.Loading.length)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.DialogData?.Data.Status === 'Done' || _ctx.DialogData?.Data.Status === 'Canceled')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT('TableToPrint1'))),
                class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT"
              }, [
                _createVNode(_component_CookiesIcon, {
                  class: "V-Auto",
                  style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
                  ID: 'Printer'
                }),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Translate('Print')), 1)
              ]),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
                class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
                style: {"background-color":"var(--colorr1)"}
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Translate('Close')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.DialogData?.Data.Status === 'Done' || _ctx.DialogData?.Data.Status === 'Canceled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                ((_ctx.DialogData?.Data.Type === 'Import' || _ctx.DialogData?.Data.Type === 'ExternalImport'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Translate('Goods entry document')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, "#" + _toDisplayString(_ctx.DialogData.Data.TransferNO), 1),
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.Translate('Supplier') + ':'), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.DialogData?.Data.SupplierName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.Translate('Date') + ':'), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.DateFormatter(_ctx.DialogData?.Data.AddedDate)), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.Translate('Driver') + ':'), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.DialogData?.Data.DriverName), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.Translate('Vehicle No') + ':'), 1),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.DialogData?.Data.VehicleNumber), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.DialogData?.Data.Type === 'Export' || _ctx.DialogData?.Data.Type === 'BranchesTransfer')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Translate('Goods release document')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, "#" + _toDisplayString(_ctx.DialogData.Data.TransferNO), 1),
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.Translate('Date') + ':'), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.DateFormatter(_ctx.DialogData?.Data.AddedDate)), 1),
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.Translate('Customer') + ':'), 1),
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.DialogData?.Data.CustomerName), 1),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.Translate('Vehicle No') + ':'), 1),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.DialogData?.Data.VehicleNumber), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type !== 'InternalTransfer' && _ctx.DialogData.Type !== 'ExternalImportHistory')
                  ? (_openBlock(), _createBlock(_component_CookiesTable, {
                      key: 2,
                      CookiesInvalidInput: _ctx.CombinedItems.length < 1,
                      ErrorData: _ctx.ErrorsVisibilty && _ctx.CombinedItems.length < 1,
                      class: "Shadow1",
                      TableSettings: _ctx.TableSettings,
                      CookiesData: _ctx.CombinedItems
                    }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"]))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.Translate('From')), 1))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createBlock(_component_CookiesTable, {
                      key: 5,
                      CookiesInvalidInput: _ctx.TransferItemsFrom.length < 1,
                      ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItemsFrom.length < 1,
                      class: "Shadow1",
                      TableSettings: _ctx.TableSettingsExport,
                      CookiesData: _ctx.TransferItemsFrom
                    }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"]))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.Translate('To')), 1))
                  : _createCommentVNode("", true),
                (_ctx.DialogData.Data.Type === 'InternalTransfer')
                  ? (_openBlock(), _createBlock(_component_CookiesTable, {
                      key: 8,
                      CookiesInvalidInput: _ctx.TransferItemsTo.length < 1,
                      ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItemsTo.length < 1,
                      class: "Shadow1",
                      TableSettings: _ctx.TableSettingsExport,
                      CookiesData: _ctx.TransferItemsTo
                    }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"]))
                  : _createCommentVNode("", true),
                _hoisted_42,
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.Translate('Notes')), 1),
                    _hoisted_47,
                    _createElementVNode("span", null, _toDisplayString((_ctx.DialogData?.Data.Notes && _ctx.DialogData?.Data.Notes !== '') ? _ctx.DialogData?.Data.Notes : _ctx.Translate('No Data')), 1)
                  ]),
                  (_ctx.DialogData.Data.Status !== 'Canceled')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.Translate('Name and Signature')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_50,
                (_ctx.DialogData.Data.Status === 'Canceled')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.Translate('Canceled')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_53,
          _hoisted_54,
          (_ctx.DialogData?.Data.Status !== 'Done' && _ctx.DialogData?.Type !== 'ExternalImportHistory' && _ctx.DialogData?.Data.Status !== 'Canceled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printIT('TableToPrint2'))),
                  class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT"
                }, [
                  _createVNode(_component_CookiesIcon, {
                    class: "V-Auto",
                    style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
                    ID: 'Printer'
                  }),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.Translate('Print')), 1)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1))),
                  class: "PrintButton Shadow2 BGRed D-Flex RowMargin NOPRINT",
                  style: {"background-color":"var(--colorr1)"}
                }, [
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.Translate('Close')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData?.Data.Status !== 'Done' && _ctx.DialogData?.Type !== 'ExternalImportHistory' && _ctx.DialogData?.Data.Status !== 'Canceled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _hoisted_59,
                _hoisted_60,
                ((_ctx.DialogData?.Data.Type === 'Import' || _ctx.DialogData?.Data.Type === 'ExternalImport'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.Translate('processing inputs')), 1))
                  : _createCommentVNode("", true),
                (_ctx.DialogData?.Data.Type === 'Export' || _ctx.DialogData?.Data.Type === 'BranchesTransfer')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.Translate('order processing')), 1))
                  : _createCommentVNode("", true),
                _hoisted_63,
                _hoisted_64,
                _createVNode(_component_CookiesTable, {
                  CookiesInvalidInput: _ctx.ExportItems.length < 1,
                  ErrorData: _ctx.ErrorsVisibilty && _ctx.ExportItems.length < 1,
                  class: "Shadow1",
                  TableSettings: _ctx.TableSettingsExport,
                  CookiesData: _ctx.$store.state.CookiesConfig[`Branch_${_ctx.$store.state.BranchManagment.CurrentBranch?.ID}_AlwaysCombineItems`] ? _ctx.CombinedItems : _ctx.ExportItems
                }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_65,
        _hoisted_66
      ])
    ])
  ], 8, _hoisted_1))
}